import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import RecipientUtils from 'src/app/shared/utils/recipient-utils';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import Polygon from '@arcgis/core/geometry/Polygon';
import { WktConverterUtils } from 'src/app/shared/utils/wkt-converter-utils';
import { SharedConstants } from 'src/app/shared/constants/shared.constants';
import { AflaModuleStrategyService } from 'src/app/shared/services/afla-module-strategy/afla-module-strategy.service';
import { SelectedApplicationService } from 'src/app/shared/services/selected-application/selected-application.service';
import { ApplicationViewService } from 'src/app/view-application/shared/application-view.service';
import { ViewApplicationBaseComponent } from 'src/app/view-application/shared/view-application-base/view-application-base.component';
import { RouterParamsService } from 'src/app/shared/services/route-params.service';
import { ViewApplicationLocationRcConstants } from './view-application-location-rc.constants';
export let ViewApplicationLocationRcComponent = class ViewApplicationLocationRcComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    changeDetectorRefs;
    routerParamsService;
    active;
    propertiesForm;
    descriptionLabel1 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationRcConstants.DESCRIPTION_LABEL_4;
    erfNoControl = ViewApplicationLocationRcConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationRcConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationRcConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationRcConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationRcConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationRcConstants.ADDRESS_CONTROL;
    ownerControl = ViewApplicationLocationRcConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationRcConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationRcConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationRcConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationRcConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationRcConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationRcConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = ViewApplicationLocationRcConstants.OWNER_LABEL;
    copyApplicantToOwnerLabel = ViewApplicationLocationRcConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = ViewApplicationLocationRcConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableAdd = true;
    ownerDisableFilterBy = true;
    ownerDisableEditing = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    ownerShowGroupsDropdown = true;
    mapComponent;
    isMapLoaded = false;
    yesNoOptions = [];
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    rcApplication;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        this.ownerGroups[0].requiredFields = stepMeta.requiredFields;
    }
    handleRouteChange() {
    }
    ngOnInit() {
        this.getMetadata();
        this.initForm();
        this.checkSave();
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    checkSave() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe(app => {
            ;
            this.rcApplication = app;
            if (this.rcApplication)
                this.syncMapExistingGeometries();
            this.changeDetectorRefs.detectChanges();
        });
    }
    singleFg(prop) {
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
        const propertyFoemGroup = new FormGroup({
            id: new FormControl(prop.id),
            applicationId: new FormControl(prop.applicationId),
            erfNo: new FormControl(prop.erfNumber),
            subdivision: new FormControl(prop.subdivision),
            allotment: new FormControl(prop.allotment),
            farmNo: new FormControl(prop.farmNumber),
            sgCode: new FormControl(prop.sgCode),
            address: new FormControl(prop.address),
            centroid: new FormControl(null),
            zones: new FormArray([], [Validators.min(1)]),
            owners: new FormControl(null),
            geometry: new FormControl(geom)
        });
        const ownerControl = propertyFoemGroup.get("owners");
        if (this.rcApplication.properties && this.rcApplication.properties.length > 0)
            RecipientUtils.setRecipients(prop.owners, true, ownerControl);
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geom));
        return propertyFoemGroup;
    }
    syncMapExistingGeometries() {
        const pa = this.getProperties();
        while (pa.controls.length > 0) {
            pa.removeAt(0);
        }
        this.rcApplication.properties.forEach((prop) => {
            pa.push(this.singleFg(prop));
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Rates certificate management graphics", true);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationRcComponent = __decorate([
    Component({
        selector: 'app-view-application-location-rc',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationLocationRcComponent);
